export default "__VITE_ASSET__8t0qEEu7__"